import { RootState } from "modules";


export const selectTest = (state: RootState) =>
  state.test